var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "popover",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: { binding: _vm.togglePopover, focus: ".code-container" },
          expression: "{binding: togglePopover, focus: '.code-container'}"
        }
      ],
      class:
        "clickable m-l-5 changelog-json-preview-btn changelog-json-popover " +
        _vm.wide
          ? "changelog-json-popover--document"
          : "",
      attrs: { placement: "left", trigger: "manual" },
      model: {
        value: _vm.showPopover,
        callback: function($$v) {
          _vm.showPopover = $$v
        },
        expression: "showPopover"
      }
    },
    [
      _c(
        "a",
        {
          staticClass: "clickable m-l-5 changelog-json-preview-btn",
          on: { click: _vm.togglePopover }
        },
        [_c("i", { staticClass: "fa fa-file-code-o m-r-5" })]
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "popover" },
        [
          _c(
            "CodeDisplay",
            {
              attrs: {
                code: _vm.diffJson,
                "success-translation": "Copied object",
                "pre-class": "m-b-0"
              }
            },
            [
              _c("div", {
                staticClass: "changelog-json-preview small",
                domProps: { textContent: _vm._s(_vm.diffJson) }
              })
            ]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }